<script>
    import { fetchGet, fetchPatch } from "../utils/utilsFetch.js";

    import {
        messageObject,
        isLoading,
        user,
        locale,
        categories,
    } from "../stores.js";

    let password;

    async function changePassword() {
        await fetchPatch(`/api/password`, {
            password,
        });
        password = "";

        $messageObject = {
            showMessage: true,
            type: "success",
            message: $locale.passwordChangedSuccessfully || "",
        };
    }

    async function changeLanguage() {
        await fetchPatch(`/api/locales/${$user.languageCode}`);
        $locale = await fetchGet(`/api/locales/${$user.languageCode}`);
        $categories = await fetchGet("/api/categories");
    }
</script>

<div class="container">
    <div class="form">
        <input
            type="password"
            placeholder={$locale.password || ""}
            bind:value={password}
        />

        <button class="btn btn-blue" on:click={changePassword}>
            {$locale.change || ""}
        </button>
    </div>

    <div class="item">
        <span>{$locale.language || ""}</span>
        <select bind:value={$user.languageCode} on:change={changeLanguage}>
            <option value="mk">mk</option>
            <option value="en">en</option>
        </select>
    </div>
</div>

<style>
    .container {
        display: flex;
        flex-direction: column;
        padding: 20px;
        gap: 20px;
    }

    .form {
        display: flex;
    }

    .form button {
        margin-left: 10px;
    }

    .item {
        display: flex;
        gap: 10px;
        align-items: center;
    }
</style>
